import request from '@/utils/request'
import { obj2query } from '@/utils'
import { getToken } from '@/utils/auth'

export function getMonthlyCharge(query) {
  return request({
    url: `/api/reports/monthlycharge${obj2query(query)}`,
    method: 'get'
  })
}
export function getExcelFile(query, filename) {
  query.access_token = getToken()
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  link.href = `${baseURL}/api/reports/monthlycharge/excel${obj2query(query)}`
  if (filename) {
    link.download = filename
  }
  link.click()
}

export function getBankaccount(query) {
  return request({
    url: `/api/reports/bankaccount${obj2query(query)}`,
    method: 'get'
  })
}

export function getBankaccountExcelFile(query, filename) {
  query.access_token = getToken()
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  link.href = `${baseURL}/api/reports/bankaccount/excel${obj2query(query)}`
  if (filename) {
    link.download = filename
  }
  link.click()
}

export function getTransaction(query) {
  return request({
    url: `/api/reports/transaction${obj2query(query)}`,
    method: 'get'
  })
}

export function getTransactionExcel(query, filename) {
  query.access_token = getToken()
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  link.href = `${baseURL}/api/reports/transaction/excel${obj2query(query)}`
  if (filename) {
    link.download = filename
  }
  link.click()
}

export function getProject(query) {
  return request({
    url: `/api/reports/project${obj2query(query)}`,
    method: 'get'
  })
}

export function getProjectExcel(query, filename) {
  query.access_token = getToken()
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  link.href = `${baseURL}/api/reports/project/excel${obj2query(query)}`
  if (filename) {
    link.download = filename
  }
  link.click()
}

export function getCompliance(query) {
  return request({
    url: `/api/reports/compliance${obj2query(query)}`,
    method: 'get'
  })
}

export function getComplianceExcel(query, filename) {
  query.access_token = getToken()
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  link.href = `${baseURL}/api/reports/compliance/excel${obj2query(query)}`
  if (filename) {
    link.download = filename
  }
  link.click()
}

export function getCard(query) {
  return request({
    url: `/api/reports/card${obj2query(query)}`,
    method: 'get'
  })
}

export function getCardExcel(query, filename) {
  query.access_token = getToken()
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  link.href = `${baseURL}/api/reports/card/excel${obj2query(query)}`
  if (filename) {
    link.download = filename
  }
  link.click()
}

export function monthlychargeVisualizationExcel(query, filename) {
  query.access_token = getToken()
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  link.href = `${baseURL}/api/reports/monthlycharge/visualization/excel${obj2query(query)}`
  if (filename) {
    link.download = filename
  }
  link.click()
}

export function webhookFail(companyuid, query) {
  return request({
    url: `/api/reports/company/${companyuid}/webhook/failed-to-deliver${obj2query(query)}`,
    method: 'get'

  })
}

export function comissionWhitelabel(companyuid, currency, query) {
  return request({
    url: `/api/reports/company/${companyuid}/whitelabel/comission/${currency}${obj2query(query)}`,
    method: 'get'
  })
}

export function getMonthlychargeLogs(query) {
  return request({
    url: `/api/reports/monthlycharge/logs${obj2query(query)}`,
    method: 'get'
  })
}

export function getMonthlychargeLogsExcel(query, filename) {
  query.access_token = getToken()
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  link.href = `${baseURL}/api/reports/monthlycharge/logs/excel${obj2query(query)}`
  if (filename) {
    link.download = filename
  }
  link.click()
}

export function getContractMovement(query) {
  return request({
    url: `/api/reports/contract${obj2query(query)}`,
    method: 'get'
  })
}

export function getContractMovementExcel(query, filename) {
  query.access_token = getToken()
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  link.href = `${baseURL}/api/reports/contract/excel${obj2query(query)}`
  if (filename) {
    link.download = filename
  }
  link.click()
}

export function getContractState(query) {
  return request({
    url: `/api/reports/contract/state${obj2query(query)}`,
    method: 'get'
  })
}

export function getContractStateExcel(query, filename) {
  query.access_token = getToken()
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  link.href = `${baseURL}/api/reports/contract/state/excel${obj2query(query)}`
  if (filename) {
    link.download = filename
  }
  link.click()
}

export function getActiveAccount(projectuid, year) {
  return request({
    url: `/api/reports/bankaccount/activesummary/${projectuid}/${year}`,
    method: 'get'
  })
}